import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControl], [formControlName]'
})
export class FormControlNativeElDirective implements OnInit {
  @Input() set formControlDisable(isDisabled: boolean) {
    if (isDisabled) {
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'disabled');
    } else {
      this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
    }
  }

    constructor(private el: ElementRef, private control: NgControl, private renderer: Renderer2) {
  }

  ngOnInit(): void {
    if (this.control?.control) this.control.control['formNativeElement'] = this.el.nativeElement;
  }
}
